import { Box, ToastContainer } from '@razorpay/blade/components';
import PageLayout from 'components/ui/Layout/PageLayout';
import React, { ReactElement } from 'react';

import { Header } from './components';
import SalaryStructureView from './SalaryStructureView';

const SalaryStructures = (): ReactElement => {
  return (
    <PageLayout
      hideHeading
      withoutBackgroundImg
      boxProps={{
        marginY: 'spacing.7',
        width: 'initial',
      }}>
      <Box paddingX="spacing.8">
        <Header />
        <SalaryStructureView />
      </Box>
      <ToastContainer />
    </PageLayout>
  );
};

export default SalaryStructures;
